import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {BodyTypeApiModel} from "../models/body-type.api-model";

@Injectable()
export class BodyTypeRestService {
  private readonly resource: string = '/body_types';

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public getBodyTypeCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<BodyTypeApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<BodyTypeApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<BodyTypeApiModel>(BodyTypeApiModel), result as object)));
  }
}
